import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';

import { Typography } from '@comparethemarketau/manor-typography';

import { ProviderLogo } from '../../products/products/common/provider_logo';
import { withQuoteFlatten } from '../../products/products/common/with_quote_flatten';

const useStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing[12]
    },
    logo: {
        marginRight: theme.spacing[8]
    },
    title: {
        fontSize: theme.fontSize.base,
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.primary800
    }
}));

const _ProductName = ({ productName, providerCode }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <div className={classes.container}>
            <ProviderLogo className={classes.logo} code={providerCode} />
            <Typography className={classes.title}>{productName}</Typography>
        </div>
    );
};

_ProductName.propTypes = {
    quote: PropTypes.object.isRequired,

    productName: PropTypes.string.isRequired,
    providerCode: PropTypes.string.isRequired
};

const ProductName = withQuoteFlatten(_ProductName);

export { ProductName };
